import { LatLngExpression } from 'leaflet'

export const convertToLatLng = (point: [number, number]): LatLngExpression => {
    return point
}
